import { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MapPin, MessageSquare, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function Contact() {
    const [loading, setLoading] = useState(false);
    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            toast.success("Message sent!", {
                description: "We'll get back within 4 business hours.",
            });
            e.target.reset();
        }, 900);
    };

    const cards = [
        {
            icon: Mail,
            title: "Email",
            value: "support@tendertrackai.com",
            sub: "Replies within 4 hours",
        },
       
        {
  icon: MapPin,
  title: "Office",
  value: "Alwar, Rajasthan",
  sub: "301414, India",
},
    ];

    return (
        <div>
            <section className="pt-20 pb-12 relative">
                <div className="absolute inset-0 mesh-bg opacity-60" />
                <div className="container-tight relative text-center max-w-3xl">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                        Contact
                    </p>
                    <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 dark:text-slate-50 text-balance">
                        Let&apos;s talk tenders.
                    </h1>
                    <p className="mt-5 text-lg text-slate-600 dark:text-slate-400">
                        Whether you&apos;re scaling bids or just exploring — we&apos;re here to help.
                    </p>
                </div>
            </section>

            <section className="pb-24">
                <div className="container-tight max-w-5xl">
                    <div className="grid lg:grid-cols-5 gap-6">
                        <div className="lg:col-span-2 space-y-4">
                            {cards.map((c) => (
                                <div
                                    key={c.title}
                                    className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 flex items-start gap-4"
                                >
                                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 dark:bg-indigo-950/50 text-indigo-600 dark:text-indigo-400">
                                        <c.icon className="h-5 w-5" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                                            {c.title}
                                        </p>
                                        <p className="mt-1 font-semibold text-slate-900 dark:text-slate-50">
                                            {c.value}
                                        </p>
                                        <p className="text-xs text-slate-500 mt-0.5">
                                            {c.sub}
                                        </p>
                                    </div>
                                </div>
                            ))}
                            <div className="rounded-2xl border border-indigo-200 dark:border-indigo-900/40 bg-gradient-to-br from-indigo-50 to-violet-50 dark:from-indigo-950/40 dark:to-violet-950/40 p-6">
                                <MessageSquare className="h-5 w-5 text-indigo-600" />
                                <p className="mt-3 font-semibold text-slate-900 dark:text-slate-50">
                                    Sales & Enterprise
                                </p>
                                <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
                                    Need volume pricing for 100+ tenders/month? Email
                                    sales@tendertrackai.com
                                </p>
                            </div>
                        </div>

                        <form
                            onSubmit={onSubmit}
                            className="lg:col-span-3 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-7"
                            data-testid="contact-form"
                        >
                            <h3 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                                Send us a message
                            </h3>
                            <p className="text-sm text-slate-500 mt-1">
                                We typically reply within a few hours.
                            </p>
                            <div className="mt-6 grid sm:grid-cols-2 gap-4">
                                <div>
                                    <Label htmlFor="name" className="text-xs font-semibold">
                                        Full Name
                                    </Label>
                                    <Input
                                        id="name"
                                        required
                                        placeholder="Arjun Mehta"
                                        className="mt-1.5"
                                        data-testid="contact-name"
                                    />
                                </div>
                                <div>
                                    <Label htmlFor="email" className="text-xs font-semibold">
                                        Work Email
                                    </Label>
                                    <Input
                                        id="email"
                                        type="email"
                                        required
                                        placeholder="you@company.in"
                                        className="mt-1.5"
                                        data-testid="contact-email"
                                    />
                                </div>
                            </div>
                            <div className="mt-4">
                                <Label htmlFor="company" className="text-xs font-semibold">
                                    Company
                                </Label>
                                <Input
                                    id="company"
                                    placeholder="Mehta Constructions Pvt. Ltd."
                                    className="mt-1.5"
                                />
                            </div>
                            <div className="mt-4">
                                <Label htmlFor="msg" className="text-xs font-semibold">
                                    Message
                                </Label>
                                <Textarea
                                    id="msg"
                                    required
                                    rows={5}
                                    placeholder="Tell us how we can help..."
                                    className="mt-1.5"
                                    data-testid="contact-message"
                                />
                            </div>
                            <Button
                                type="submit"
                                disabled={loading}
                                className="mt-6 w-full h-11 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold"
                                data-testid="contact-submit"
                            >
                                {loading ? "Sending..." : "Send Message"}
                                <Send className="ml-2 h-4 w-4" />
                            </Button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}
